module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.7@core-js/library/modules/_library.js
// module id = 106
// module chunks = 1